export function IsNull<T>(value: T): boolean {
    return value === undefined || value == null || typeof value == 'undefined';
}

export function IsNotNull<T>(value: T): boolean {
    return value != undefined && value != null && typeof value != 'undefined';
}

export function IsNullOrEmpty<T>(value: T): boolean {
    return value === undefined || value == null || typeof value == 'undefined' || (typeof value == 'string' && value.trim() === '');
}

export function IsNotNullOrEmpty<T>(value: T): boolean {
    return value != undefined && value != null && typeof value != 'undefined' && (typeof value == 'string' && value.trim() != '');
}

export function IsFalse(value: any): boolean {
    return value == undefined || value == null || typeof value == 'undefined' || value == false;
}

export function IsTrue(value: any): boolean {
    return value != undefined && value != null && typeof value != 'undefined' && value == true;
}

export function IsZeroNumber(value: number): boolean {
    return value === undefined || value == null || typeof value == 'undefined' || (typeof value == 'number' && value === 0);
}

export function IsNotZeroNumber(value: number): boolean {
    return value !== undefined && value != null && typeof value != 'undefined' && (typeof value == 'number' && value != 0);
}

export function IsZero(value: number): boolean {
    return value === undefined || value == null || typeof value == 'undefined' || value === 0;
}

export function IsNotZero(value: number): boolean {
    return value !== undefined && value != null && typeof value != 'undefined' && value != 0;
}

export function IsAny<T>(value: Array<T>): boolean {
    return IsNotNull(value) && value.length > 0;
}

export function IsNotAny<T>(value: Array<T>): boolean {
    return IsNull(value) || value.length == 0;
}

export function FirstOrDefault<T>(value: Array<T>): T {
    return IsAny(value) ? value[0] : null;
}